import React from 'react';
import PropTypes from 'prop-types';
import GatsbyLink from 'gatsby-link';

// This is required because in the CMS we don't want to render real working links.
export class Link extends React.Component {
	static contextTypes = {
		previewMode: PropTypes.bool,
	};

	static propTypes = {
		href: PropTypes.string,
	};

	render() {
		const { previewMode } = this.context;

		if (previewMode) {
			return <a {...this.props} />;
		} else if (this.props.href) {
			return <a target="_blank" rel="noopener noreferrer" {...this.props} />;
		} else {
			return <GatsbyLink {...this.props} />;
		}
	}
}

export { navigateTo } from 'gatsby-link';

// This seems to be the thing you do. That's what GatsbyLink is doing...?
// https://github.com/gatsbyjs/gatsby/blob/3acce966dc4583b17d849ad74c6753bc259a8338/packages/gatsby-link/src/index.js#L188
export const goBack = () => {
	window.___history.goBack();
};



// WEBPACK FOOTER //
// ./src/components/shared/link/component.js